import React, { useState, useEffect } from 'react';

import { SingleText } from '../../Res/BaseInput';
import { Space, SingleBigButton } from '../../Res/BaseButton';
import { ContentBox } from '../../Content/ContentBox';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { getval2Token, setVal2Token } from '../../../Login/Auth';
import { ManagementPrompt } from '../../Res/ManagementPrompt';
import { RecruitmentContractorStatusResume } from './RecruitmentContractorStatusResume';
import { RecruitmentContractorStatusProcess } from './RecruitmentContractorStatusProcess';
import { RespRecruitmentContractorDetail, JOB_STATUS_RESTART, JOB_STATUS_RESTART_STRING } from '../../../../item/ItemRecruitmentContractor';
import moment from 'moment';
import { getCaseStatus, ReqRecruitmentContractorStatusDetail } from '../../../../item/ItemRecruitmentContractorStatus';
import { api_getRecruitmentContractorDetail } from '../../../../api/apiRecruitmentContractor';
import { ReqInsurance, RespInsurance } from '../../../../item/ItemInsurance';
import { api_getRecruitmentContractorInsurance } from '../../../../api/apiRecruitmentContractorInsurance';


export function RecruitmentContractorStatusDetail({ id, setIsLoading, isEdit = false, isML = false, isAll = false }) {
  const [tokenId, setTokenId] = useState("")
  const [resumeId, setResumeId] = useState("")
  const [recruitmentContractorId, setRecruitmentContractorId] = useState("")
  const [item, setItem] = useState(null)
  const [isBlacklist, setIsBlacklist] = useState(false)
  const [isBlacklistStr, setIsBlacklistStr] = useState("")

  const [name, setName] = useState("")
  const [contractorJobStatusDescription, setContractorJobStatusDescription] = useState("")
  const [sex, setSex] = useState("")
  const [age, setAge] = useState("")
  const [mobile, setMobile] = useState("")
  const [contractorSupervisor, setContractorSupervisor] = useState("")
  const [companyName, setCompanyName] = useState("")
  const [job, setJob] = useState("")
  const [workPlace, setWorkPlace] = useState("")
  const [workAddress, setWorkAddress] = useState("")
  const [laborInsuranceStatusDescription, setLaborInsuranceStatusDescription] = useState("")
  // const [laborPensionStatusDescription, setLaborPensionStatusDescription] = useState("")
  const [healthInsuranceStatusDescription, setHealthInsuranceStatusDescription] = useState("")
  const [insuranceGUI, setInsuranceGUI] = useState("")
  const [groupInsuranceStatusDescription, setGroupInsuranceStatusDescription] = useState("")
  const [groupInsuranceGUI, setGroupInsuranceGUI] = useState("")

  const [showViewResume, setShowViewResume] = useState(false)
  const [showViewProcess, setShowViewProcess] = useState(false)

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      var obj = getval2Token("recruitmentContractorStatus", id)
      console.log(obj)
      // var rId = getval2Token("resumeId", id)
      setResumeId(obj.resumeId)
      // setItem(obj.item)
      setTokenId(id)
    }
  }, [id])

  // useEffect(() => {
  //   if (item !== null) {
  //     console.log(item)
  //     if (item.isBlack) {
  //       setIsBlacklist(true)
  //       setIsBlacklistStr("--黑名單")
  //     }
  //     setName(item.name)
  //     // var statusDescription = ""
  //     // switch (item.contractorJobStatus) {
  //     //   case CASE_STATUS_START:
  //     //     statusDescription = "新人" + moment(item.caseCreateDate).format('YYYY/MM/DD')
  //     //     break;
  //     //   case CASE_STATUS_CANCEL:
  //     //     statusDescription = "未報到" + moment(item.caseCancelDate).format('YYYY/MM/DD')
  //     //     break;
  //     //   case CASE_STATUS_RESIGN:
  //     //     statusDescription = "已離職" + moment(item.caseResignDate).format('YYYY/MM/DD')
  //     //     break;
  //     //   default:
  //     //     break;
  //     // }
  //     var mRespRecruitmentContractorDetail = new RespRecruitmentContractorDetail({})
  //     mRespRecruitmentContractorDetail.fromJson(item)
  //     var cs = getCaseStatus(mRespRecruitmentContractorDetail, mRespRecruitmentContractorDetail.caseInfo)
  //     // console.log(item.caseInfo)
  //     // console.log(cs)
  //     setContractorJobStatusDescription(item.contractorJobStatusDescription + " " +moment(cs.statusDeta).format('YYYY/MM/DD'))
  //     const startDate = moment(item.birthday);
  //     const endDate = moment(new Date());
  //     const age = endDate.diff(startDate, 'years');
  //     setAge(age)
  //     setSex(item.sex === "1" ? "男" : item.sex === "1" ? "女" : "")
  //     setMobile(item.mobile)
  //     setContractorSupervisor(item.caseOwnerName)
  //     if (item.contractorJobStatus === 0) {
  //       setCompanyName("N/A")
  //       setJob("N/A")
  //       setWorkPlace("N/A")
  //       setWorkAddress("N/A")
  //     }
  //   }
  // }, [item])

  useEffect(() => {
    if (resumeId !== undefined && resumeId !== "") {
      getDetail()
    }
  }, [resumeId])

  useEffect(()=>{
    if(recruitmentContractorId !== "")
      getInsurance()
  }, [recruitmentContractorId])

  function getDetail() {
    setIsLoading(true)
    var mReqRecruitmentContractorStatusDetail = new ReqRecruitmentContractorStatusDetail({
      caseContractor: resumeId
    })
    api_getRecruitmentContractorDetail({
      mReqRecruitmentContractorStatusDetail,
      success: (jsonData) => {
        var detail = jsonData.detail
        console.log(detail)
        setVal2Token('recruitmentContractorStatusDetail', detail, tokenId)
        // setVal2Token('recruitmentContractorStatusDetailInsurance', jsonData.insurance, tokenId)
        setItem(detail)
        if (detail.isBlacklist) {
          setIsBlacklist(true)
          setIsBlacklistStr("--黑名單")
        }
        console.log(detail)
        console.log(detail.name)
        setName(detail.name)

        var mRespRecruitmentContractorDetail = new RespRecruitmentContractorDetail({})
        mRespRecruitmentContractorDetail.fromJson(detail)
        var cs = getCaseStatus(mRespRecruitmentContractorDetail, mRespRecruitmentContractorDetail.caseInfo)
        console.log(mRespRecruitmentContractorDetail)
        setRecruitmentContractorId(mRespRecruitmentContractorDetail.recruitmentContractorId)
        // console.log(cs)
        var contractorJobStatusDescription = ""
        if (detail.contractorJobStatusDescription === "") {
          if (detail.contractorJobStatus + "" === JOB_STATUS_RESTART) {
            contractorJobStatusDescription = JOB_STATUS_RESTART_STRING
          }
        } else {
          contractorJobStatusDescription = detail.contractorJobStatusDescription + " " + moment(cs.statusDeta).format('YYYY/MM/DD')
        }
        setContractorJobStatusDescription(contractorJobStatusDescription)
        const startDate = moment(detail.birthday);
        const endDate = moment(new Date());
        const age = endDate.diff(startDate, 'years');
        setAge(age)
        setSex(detail.sex === "1" ? "男" : detail.sex === "2" ? "女" : "")
        setMobile(detail.mobile)
        setContractorSupervisor(detail.caseOwnerName)
        if (detail.contractorJobStatus === 0) {
          setCompanyName("N/A")
          setJob("N/A")
          setWorkPlace("N/A")
          setWorkAddress("N/A")
        } else {
          setCompanyName(mRespRecruitmentContractorDetail.caseInfo.caseCompanyName)
          setJob(mRespRecruitmentContractorDetail.caseInfo.caseCustomerPosition)
          setWorkPlace(mRespRecruitmentContractorDetail.caseInfo.caseWorkPlace)
          setWorkAddress(mRespRecruitmentContractorDetail.caseInfo.caseWorkAddress)
        }

        // var mRespInsurance = new RespInsurance({})
        // mRespInsurance.fromJson(jsonData.insurance)
        // console.log(mRespInsurance)
        // setLaborInsuranceStatusDescription(mRespInsurance.laborInsurance.description)
        // // setLaborPensionStatusDescription(mRespInsurance.laborPension.description)
        // setHealthInsuranceStatusDescription(mRespInsurance.healthInsurance.description)
        // setInsuranceGUI(mRespInsurance.insuredUnitGUI===""?'N/A':mRespInsurance.groupInsurance.insuredUnitGUI)
        // setGroupInsuranceStatusDescription(mRespInsurance.groupInsurance.description)
        // setGroupInsuranceGUI(mRespInsurance.groupInsurance.groupInsuranceGUI===""?'N/A':mRespInsurance.groupInsurance.groupInsuranceGUI)
        setIsLoading(false)
      },
      failure: (err) => {
        setIsLoading(false)
      }
    })
  }
  function getInsurance() {
    setIsLoading(true)
    var mReqInsurance = new ReqInsurance({
      caseContractor: resumeId,
      recruitmentContractorId: recruitmentContractorId
    })
    console.log(mReqInsurance)
    api_getRecruitmentContractorInsurance({
      mReqInsurance,
      success: (jsonData) => {
        console.log(jsonData)
        var mReqInsurance = new ReqInsurance({})
        mReqInsurance.fromJson(jsonData.insurance)
        console.log(mReqInsurance)
        console.log(mReqInsurance.insuranceInfo)

        var mRespInsurance = new RespInsurance({})
        if (mReqInsurance.insuranceInfo){
          mRespInsurance.fromJson(mReqInsurance.insuranceInfo)
          // mRespInsurance.fromJson(JSON.parse(mReqInsurance.insuranceInfo))
        }
        console.log(mRespInsurance)
        // setInsurance(mRespInsurance)

        // setInsuranceUnitGUI(mRespInsurance.insuredUnitGUI)
        setInsuranceGUI(mRespInsurance.insuredUnitGUI === "" ? 'N/A' : mRespInsurance.insuredUnitGUI)
        setLaborInsuranceStatusDescription(mRespInsurance.laborInsurance.description)
        setHealthInsuranceStatusDescription(mRespInsurance.healthInsurance.description)
        // setGroupInsuranceGUI(mRespInsurance.groupInsurance.groupInsuranceGUI)
        setGroupInsuranceStatusDescription(mRespInsurance.groupInsurance.description)
        setGroupInsuranceGUI(mRespInsurance.groupInsurance.groupInsuranceGUI === "" ? 'N/A' : mRespInsurance.groupInsurance.groupInsuranceGUI)
        setIsLoading(false)
      },
      failure: (err) => {
        setIsLoading(false)
      }
    })
  }

  function toReserveSOP() {
    window.location.assign("/ReserveSOP/" + tokenId);
  }

  function toReviseSOP() {
    window.location.assign("/ReviseSOP/" + tokenId);
  }

  function toCancel() {
    window.history.back();
  }

  function toInsuranceReviseSOP() {
    window.location.assign("/InsuranceReviseSOP/" + tokenId);
  }

  function toViewResume() {
    setShowViewResume(true)
    setShowViewProcess(false)
  }

  function toViewProcess() {
    setShowViewResume(false)
    setShowViewProcess(true)
  }

  var superTitle = name + isBlacklistStr
  var title = "目前的工作狀態"
  var title_tools =
    isAll ?
      // <a className="dropdown-toggle " onClick={e => toReviseSOP()} data-toggle="dropdown" href="#A">
      //   <i className="fa fa-pencil text-warning"></i><span className="text-warning m-l-xs">進行案件修正作業</span>
      // </a>
      <></> :
      <a className="dropdown-toggle " onClick={e => toReserveSOP()} data-toggle="dropdown" href="#A">
        <i className="fa fa-pencil text-warning"></i><span className="text-warning m-l-xs">進行預定作業</span>
      </a>
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"工作狀態"} val={contractorJobStatusDescription} />
          <SingleText title={"性別/年齡"} val={sex + "/" + age} />
          <SingleText title={"手機號碼"} val={mobile} />
          <SingleText title={"直屬專員"} val={contractorSupervisor} />
        </div>
      </div>
      <Space />
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"合約廠商"} val={companyName} />
          <SingleText title={"職缺"} val={job} />
          <SingleText title={"工作地點"} val={workPlace} />
          <SingleText title={"工作地址"} val={workAddress} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"勞保勞退狀態"} val={laborInsuranceStatusDescription} />
          {/* <SingleText title={"勞退狀態"} val={laborPensionStatusDescription} /> */}
          <SingleText title={"健保狀態"} val={healthInsuranceStatusDescription} />
          <SingleText title={"投保單位統編"} val={insuranceGUI} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"團保狀態"} val={groupInsuranceStatusDescription} />
          <SingleText title={"保險公司統編"} val={groupInsuranceGUI} />
        </div>
      </div>
      {
        isAll ?
          <>
            <div className="hr-line-dashed"></div>
            <div className="row">
              <div className="col-md-12">
                <SingleBigButton name={"保險資訊修正作業"} action={toInsuranceReviseSOP} />
                <div className="col-md-9">
                  <p className="text-success">如果保險資訊有錯誤，可以按此按鈕，進行保險資訊修正作業</p>
                </div>
                <div className="col-md-9">
                  <p className="text-success">注意：在職、離職的情況不同，會影響保費的計算，請自行追蹤！</p>
                </div>
              </div>
            </div>
          </>
          : <></>
      }
    </>

  var moreTitle = "更多詳細資料，請點選下方按鈕"
  var moreContent =
    <>
      <div className="row">
        <div className="col-md-12">
          <SingleBigButton name={"檢視履歷表"} action={toViewResume} />
          <SingleBigButton name={"檢視派遣歷程"} action={toViewProcess} />
        </div>
      </div>
    </>

  return (
    <>
      <ContentBox superTitle={superTitle} title={title} titleSize={6} content={content} title_tools={title_tools} hasDrawer={false} />
      <ContentBox title={moreTitle} titleSize={6} content={moreContent} hasDrawer={false} />
      {!showViewResume ? <></> :
        <RecruitmentContractorStatusResume rId={resumeId} setIsLoading={setIsLoading} isAdmin={isML || isAll} />
      }
      {!showViewProcess ? <></> :
        <RecruitmentContractorStatusProcess id={tokenId} ibl={isBlacklist} ibls={isBlacklistStr} n={name} setIsLoading={setIsLoading} isAll={isAll} />
      }
      <ManagementPrompt />
      <SystemPromptInput />
    </>
  )
}